import AbstractService from './AbstractService';

export default class NotificationService extends AbstractService {
  url(url) {
    return `/notifications${url}`;
  }

  readAll() {
    return this.http.put(this.url('/readAll'));
  }

  async sendNotification(obj) {
  	const response = await this.http.post(this.url('/inserNotification'), obj);
  	return response.status;
  }

  async sendTaskNotification(obj, desc) {
    const params = {
      description: desc,
    };
    const response = await this.http.post(this.url('/insertTaskNotification'), obj, { params });
    return response.status;
  }
  async updateTaskStatusNotification(task) {
    const data = await this.http.put(this.url('/updateTaskStatusNotification/'), task);
    return data;
  }
}
